/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { IFormITR1 } from "../../../config/interfaces";
import PriceDisplay from "../../PriceDisplay";
import { ContextAwareToggle } from "../../accordion";

type Props = {};

const AccCapitalGainsIncome: React.FC<Props> = (props: Props) => {
  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      {values.TotalCapitalGains ? (
        <>
          <Accordion.Item eventKey="income-source-4">
            <ContextAwareToggle eventKey="income-source-4" isChild={true}>
              <div className="btn-content justify-content-between">
                <p className="leading-para fw-bold mb-0">Capital Gains</p>
                <p className="leading-para fw-bold mb-0">
                  <PriceDisplay price={values.TotalCapitalGains} />
                </p>
              </div>
            </ContextAwareToggle>
            <Accordion.Body>
              <section>
                <dl className="eds-list eds-dl eds-inline-between">
                  <RenderListItem title="Stocks" income={values.CapitalGains.TotalStocksGain} />

                  <RenderListItem
                    title="Mutual Fund"
                    income={values.CapitalGains.TotalMutualFundsGain}
                  />

                  <RenderListItem
                    title="Foreign Shares"
                    income={values.CapitalGains.TotalForeignSharesGain}
                  />

                  <RenderListItem
                    title="Sale of Land and Building"
                    income={values.CapitalGains.TotalLandBuildingGain}
                  />

                  <RenderListItem
                    title="Stock Options and RSUs"
                    income={values.CapitalGains.TotalStockOptionsRSUsGain}
                  />

                  <RenderListItem
                    title="Bonds and Debenture"
                    income={values.CapitalGains.TotalBondsDebentureGain}
                  />

                  <RenderListItem
                    title="Deemed Capital Gains"
                    income={values.CapitalGains.TotalDeemedCapitalGain}
                  />

                  <RenderListItem
                    title="Any Other Assets"
                    income={values.CapitalGains.TotalAnyOtherAssetsGain}
                  />

                  <div className="eds-list--item eds-list--item-subtotal">
                    <dt>Total:</dt>
                    <dd>
                      <PriceDisplay price={values.TotalCapitalGains} />
                    </dd>
                  </div>
                </dl>
              </section>
            </Accordion.Body>
          </Accordion.Item>
        </>
      ) : null}
    </>
  );
};

export default AccCapitalGainsIncome;

const RenderListItem = ({ income, title }: { income: number; title: string }) => {
  return (
    <>
      {income ? (
        <div className="eds-list--item">
          <dt>{title}</dt>
          <dd>
            <PriceDisplay price={income} />
          </dd>
        </div>
      ) : null}
    </>
  );
};
